import {
  Facebook,
  Twitter,
  Linkedin,
  Youtube,
  Phone,
  Mail,
  Clock,
  Smartphone,
  Download,
  Apple,
  Play,
  QrCode,
} from "lucide-react";
import { Link } from "wouter";
import { useBranding } from "@/shared/contexts/BrandingContext";

export default function Footer() {
  const { currentBrand, isAegis360, isGreenshield } = useBranding();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand-specific Company Info */}
          <div>
            <div className="mb-4">
              <div>
                <h1 className="text-xl font-bold tracking-wide">
                  {currentBrand.name.toUpperCase()}
                </h1>
                <p
                  className={`text-xs font-semibold uppercase tracking-wider ${
                    isAegis360 ? "text-blue-400" : "text-emerald-400"
                  }`}
                >
                  {isAegis360 ? "SaaS Platform" : "Pest Management Ltd"}
                </p>
              </div>
            </div>
            <p className="mb-4">
              {isAegis360
                ? "AI-powered SaaS platform for pest control businesses. Increase efficiency, profit, and customer satisfaction with cutting-edge technology and automation."
                : "Professional Pest Control Solutions – Advanced Technology Meets Eco-Smart Protection. RSPH certified, insured, and committed to safe, effective pest management solutions."}
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href="#"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                <Twitter className="h-6 w-6" />
              </a>
              <a
                href="#"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                <Linkedin className="h-6 w-6" />
              </a>
              <a
                href="#"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Brand-specific Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">
              {isAegis360 ? "Platform Features" : "Our Services"}
            </h4>
            <ul className="space-y-2">
              {isAegis360 ? (
                <>
                  <li>
                    <Link
                      href="/ai-intelligence"
                      className="hover:text-blue-400 transition-colors"
                    >
                      AI Pest Identification
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/pricing-admin"
                      className="hover:text-blue-400 transition-colors"
                    >
                      Smart Quoting Engine
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/iot-pest-sensors"
                      className="hover:text-blue-400 transition-colors"
                    >
                      IoT Integration
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/predictive-calendar"
                      className="hover:text-blue-400 transition-colors"
                    >
                      Predictive Analytics
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/field-technician"
                      className="hover:text-blue-400 transition-colors"
                    >
                      Mobile Technician App
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/case-studies"
                      className="hover:text-blue-400 transition-colors"
                    >
                      Customer Success Stories
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link
                      href="/residential-services"
                      className="hover:text-emerald-400 transition-colors"
                    >
                      Residential Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/commercial-solutions"
                      className="hover:text-emerald-400 transition-colors"
                    >
                      Commercial Solutions
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/industrial-solutions"
                      className="hover:text-emerald-400 transition-colors"
                    >
                      Industrial Solutions
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/emergency-pest-control"
                      className="hover:text-emerald-400 transition-colors"
                    >
                      Emergency Response
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/specialist-services"
                      className="hover:text-emerald-400 transition-colors"
                    >
                      Specialist Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/eco-recommendation-engine"
                      className="text-gray-300 hover:text-emerald-400 transition-colors"
                    >
                      Eco-Friendly Solutions
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/about-us"
                  className="hover:text-emerald-400 transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  href="/service-areas"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Service Areas
                </Link>
              </li>
              <li>
                <Link
                  href="/case-studies"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Case Studies
                </Link>
              </li>
              <li>
                <Link
                  href="/reviews"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Customer Reviews
                </Link>
              </li>
              <li>
                <Link
                  href="/careers"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  href="/pricing"
                  className="hover:text-emerald-400 transition-colors"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Brand-specific Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Information</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Phone
                  className={`${isAegis360 ? "text-blue-400" : "text-emerald-400"}`}
                  size={18}
                />
                <div>
                  <div className="font-medium">
                    {isAegis360 ? "+44-800-AEGIS360" : "07913024492"}
                  </div>
                  <div className="text-sm text-gray-400">
                    {isAegis360 ? "Sales Enquiry Line" : "24/7 Emergency Line"}
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <Mail
                  className={`${isAegis360 ? "text-blue-400" : "text-emerald-400"}`}
                  size={18}
                />
                <div>
                  <div className="font-medium">
                    {isAegis360
                      ? "sales@aegis360.co.uk"
                      : "info@greenshieldpestmanagement.co.uk"}
                  </div>
                  <div className="text-sm text-gray-400">
                    {isAegis360 ? "Sales & Support" : "General Enquiries"}
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <Clock
                  className={`${isAegis360 ? "text-blue-400" : "text-emerald-400"}`}
                  size={18}
                />
                <div>
                  <div className="font-medium">
                    {isAegis360 ? "Mon-Fri: 9AM-6PM" : "Mon-Fri: 8AM-6PM"}
                  </div>
                  <div className="text-sm text-gray-400">
                    {isAegis360
                      ? "Business Hours"
                      : "Weekend Emergency Available"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile App Download */}
          <div>
            <h4 className="text-white font-semibold mb-4 flex items-center">
              <Smartphone className="h-5 w-5 mr-2 text-emerald-400" />
              Download Our App
            </h4>
            <div className="space-y-4">
              <p className="text-sm text-gray-400 mb-4">
                Get instant pest identification, quick booking, and 24/7 support
                on your mobile device.
              </p>

              {/* App Store Buttons */}
              <div className="space-y-3">
                <a
                  href="/download-app"
                  className="flex items-center space-x-3 bg-black hover:bg-gray-800 text-white px-4 py-2 rounded-lg transition-colors group"
                >
                  <Apple className="h-6 w-6" />
                  <div className="text-left">
                    <div className="text-xs text-gray-300">Download on the</div>
                    <div className="text-sm font-semibold">App Store</div>
                  </div>
                </a>

                <a
                  href="/download-app"
                  className="flex items-center space-x-3 bg-black hover:bg-gray-800 text-white px-4 py-2 rounded-lg transition-colors group"
                >
                  <Play className="h-6 w-6" />
                  <div className="text-left">
                    <div className="text-xs text-gray-300">Get it on</div>
                    <div className="text-sm font-semibold">Google Play</div>
                  </div>
                </a>
              </div>

              {/* Quick Features */}
              <div className="mt-4 pt-4 border-t border-gray-700">
                <div className="flex items-center space-x-2 text-xs text-gray-400 mb-2">
                  <QrCode className="h-4 w-4 text-emerald-400" />
                  <span>Quick Features:</span>
                </div>
                <ul className="text-xs text-gray-400 space-y-1">
                  <li>• AI Pest Identification</li>
                  <li>• Instant Booking</li>
                  <li>• Live Tracking</li>
                  <li>• Emergency Support</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Brand-specific CTA */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          {isAegis360 ? (
            <div className="bg-blue-600 rounded-lg p-6 text-center">
              <div className="text-white font-semibold mb-4">
                Ready to Transform Your Pest Control Business?
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link href="/book-demo">
                  <button className="bg-white text-blue-600 px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors">
                    {currentBrand.primaryCTA}
                  </button>
                </Link>
                <Link href="/pricing">
                  <button className="bg-transparent border-2 border-white text-white px-6 py-3 rounded font-semibold hover:bg-white hover:text-blue-600 transition-colors">
                    {currentBrand.secondaryCTA}
                  </button>
                </Link>
              </div>
            </div>
          ) : (
            <div className="bg-red-600 rounded-lg p-6 text-center">
              <div className="text-white font-semibold mb-4">
                Emergency Pest Problem?
              </div>
              <button className="bg-white text-red-600 px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors">
                Call Now: 07913024492
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2024 {currentBrand.name}. All rights reserved.
            </div>

            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
              <Link
                href="/privacy-policy"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms-of-service"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                Terms of Service
              </Link>
              <Link
                href="/security"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                Security
              </Link>
              <Link
                href="/cookie-policy"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                Cookie Policy
              </Link>
              <Link
                href="/faq"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                FAQ
              </Link>
              <Link
                href="/blog"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                Blog
              </Link>
              <Link
                href="/enterprise"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                Enterprise
              </Link>
              <Link
                href="/sitemap"
                className={`text-gray-400 transition-colors ${
                  isAegis360 ? "hover:text-blue-400" : "hover:text-emerald-400"
                }`}
              >
                Sitemap
              </Link>
              <span className="text-gray-400">Company No. 16187575</span>
            </div>
            <div className="text-gray-400 text-sm">
              BPCA Certified & Insured | HSE Approved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
